import { render, staticRenderFns } from "./OrderDiscount.vue?vue&type=template&id=3f4160b6&scoped=true&"
import script from "./OrderDiscount.vue?vue&type=script&lang=js&"
export * from "./OrderDiscount.vue?vue&type=script&lang=js&"
import style0 from "./OrderDiscount.vue?vue&type=style&index=0&id=3f4160b6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4160b6",
  null
  
)

export default component.exports